'use client'

import { CustomerLoginModal } from './customer-login.modal'
import { CustomerVerifyPhoneModal } from './customer-verify-phone'

export const CustomerLoginModals = () => {
  return (
    <>
      <CustomerLoginModal />
      <CustomerVerifyPhoneModal />
    </>
  )
}
